import { render, staticRenderFns } from "./ConfirmationSummaryBlock.vue?vue&type=template&id=2d325188&"
import script from "./ConfirmationSummaryBlock.vue?vue&type=script&lang=js&"
export * from "./ConfirmationSummaryBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports